'use client';

/**
 * Users end up here if they request an unknown endpoint/page
 *
 * @packageDocumentation
 * @category Page
 */

import { Button, Section } from '@bomdisoft/components';
import { getLanguageFromLocale, returnHome } from '@bomdisoft/translations';
import s from '@pieleaf/app/styles.module.css';
import { useParams, useRouter } from 'next/navigation';

const NotFound = () => {
  const params = useParams();
  const language = getLanguageFromLocale(params.lang as string);
  const router = useRouter();

  return (
    <Section className={s.section}>
      <Button data-prodantix='Go to the home page' onClick={() => router.push('/')} variant='contained'>
        {returnHome[language]}
      </Button>
    </Section>
  );
};

export default NotFound;
